import { ActivityListResponse, AuditLog } from '@/models/AuditLog';
import { apiClient } from '@/services/api';
import { logger } from '@/utils/logger/loggerInstance';

export const getActivity = async (
  propertyId: string,
  limit?: number,
  cursor?: string,
): Promise<ActivityListResponse> => {
  const params = new URLSearchParams();
  if (limit) params.append('limit', String(limit));
  if (cursor) params.append('cursor', cursor);

  const queryString = params.toString();
  const url = `/property/${propertyId}/activity${queryString ? `?${queryString}` : ''}`;

  logger.debug(`GET ${url}`);
  const response = await apiClient.get<ActivityListResponse>(url);

  return response.data;
};

export const logPropertyView = async (propertyId: string): Promise<AuditLog> => {
  const url = `/property/${propertyId}/activity/view`;

  logger.debug(`POST ${url}`);
  const response = await apiClient.post<AuditLog>(url);

  return response.data;
};
